import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import { mergeStyleSets } from '@fluentui/react';
import { Button, makeStyles } from '@fluentui/react-components';
import { ChevronDownRegular, ChevronRightRegular } from '@fluentui/react-icons';
import React, { PropsWithChildren, useState } from 'react';
import { accordionFilterHeaderStyles } from '../../../app/common/styles/CommonStyleObjects';

const stackStyles = mergeStyleSets({ root: { borderBottom: '1px solid #E5E5E5' } });

type CollapsibleProps = PropsWithChildren<{
  text: string;
}>;

const useStyles = makeStyles({
  stackItemPadding: { padding: '10px' },
});

const Collapsible = (props: CollapsibleProps): JSX.Element => {
  const { text, children } = props;
  const [contentIsCollapsed, setContentIsCollapsed] = useState(true);
  const classes = useStyles();

  return (
    <Stack className={stackStyles.root}>
      <Stack horizontal horizontalAlign="space-between">
        <Button
          appearance="transparent"
          style={{ ...accordionFilterHeaderStyles.root } as React.CSSProperties}
          onClick={(): void => {
            setContentIsCollapsed(!contentIsCollapsed);
          }}
        >
          {text}
        </Button>
        <Stack verticalFill verticalAlign="center">
          <Button
            appearance="subtle"
            icon={contentIsCollapsed ? <ChevronRightRegular /> : <ChevronDownRegular />}
            title={contentIsCollapsed ? `Expand ${text}` : `Collapse ${text}`}
            aria-label={contentIsCollapsed ? `Expand ${text}` : `Collapse ${text}`}
            aria-expanded={!contentIsCollapsed}
            onClick={(): void => {
              setContentIsCollapsed(!contentIsCollapsed);
            }}
          />
        </Stack>
      </Stack>
      {!contentIsCollapsed && (
        <StackItem className={classes.stackItemPadding}>{children}</StackItem>
      )}
    </Stack>
  );
};

export default Collapsible;
